<template>
  <div>
    <transition name="welfareScale" v-on:after-leave="$emit('closed')">
      <div class="bind-wrap" ref="welScaleWrap" v-if="showContent">
        <div class="welfare-bind">
          <div class="close" @click="showContent = !showContent"></div>
          <div class="content">
            <div class="bind-title"><AutoFontSize v-if="isShow">{{ $t('welfare_bind_title') }}</AutoFontSize></div>
            <div class="line line-1"><AutoFontSize v-if="isShow">{{ $t('welfare_bind_tips_1') }}</AutoFontSize></div>
            <div class="line line-2">{{ $t('welfare_bind_tips_2') }}</div>
            <div class="award"></div>
            <div class="btn" @click="onBtnBindClick">{{ $t('welfare_bind_btn') }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import mixins from './mixins'
import { mapGetters } from 'vuex'
export default {
  name: 'BindAccount',
  mixins: [mixins],
  data () {
    return {
      showContent: true
    }
  },
  created () {
    if (this.bindAccountNum > 0) {
      return this.$emit('delPopup', 'BindAccount')
    }
  },
  computed: {
    ...mapGetters(['bindAccountNum'])
  },
  methods: {
    startShow () {
      this.$utils.setTransOrigin(document.querySelector('.entrance-wrapper'), this.$refs.welScaleWrap)
      this.$bus.$on('after-bind-visitor-login', () => {
        this.$emit('closed', { name: 'ArrivalPanel', options: { type: 'bind' } })
      })
    },
    onBtnBindClick () {
      // 标记打开绑定窗口位置
      localStorage.setItem('log-bind-entry', 'loading_pop_up')
      this.$bus.$emit('welfare-events', 'bindAccount')
      this.$utils.log('bind_account', { bind_channel: 'loading_pop_up' })
    }
  },
  beforeDestroy () {
    this.$bus.$off('after-bind-visitor-login')
  }
}
</script>

<style lang='scss' scoped >
.welfareScale-enter-active, .welfareScale-leave-active {
  transition: all .5s;
}
.welfareScale-enter, .welfareScale-leave-to {
  opacity: 0;
  transform: scale(0);
}
.bind-wrap {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 0;
}
.welfare-bind {
  width: calc(1698 * var(--unit-px));
  height: calc(884 * var(--unit-px));
  background: url(~@/assets/img/bg_popup_bind.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  margin-top: calc(-165 * var(--unit-px));
}
.close {
  width: calc(82 * var(--unit-px));
  height: calc(82 * var(--unit-px));
  background: url(~@/assets/img/welfare/icon_close.png) no-repeat center center;
  background-size: 100% 100%;
  position: absolute;
  top: calc(170 * var(--unit-px));
  right: calc(97 * var(--unit-px));
  cursor: pointer;
}
.content {
  position: absolute;
  z-index: 3;
  top: calc(307 * var(--unit-px));
  right: calc(160 * var(--unit-px));
  width: calc(769 * var(--unit-px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .bind-title {
    text-align: right;
    font-size: calc(54 * var(--unit-px));
    height: calc(79 * var(--unit-px));
    font-weight: bold;
    width: calc(100% + calc(70 * var(--unit-px)));
    .auto-font-size {
      text-align: right;
    }
    ::v-deep(span) {
      color: #FFE05B;
      line-height: 1.4;
      text-shadow: 0px 1px 2px #000000;
      background: linear-gradient(180deg, #FCF5DC 0%, #E4C78A 100%);
      -webkit-background-clip: text;
    }
  }
  div {
    flex-shrink: 0;
  }
  .line {
    text-align: right;
    font-size: calc(27 * var(--unit-px));
    line-height: calc(37 * var(--unit-px));
    font-weight: bold;
    color: #ffffff;
  }
  .line-1 {
    margin-top: calc(35 * var(--unit-px));
  }
  .line-2 {
    height: calc(37 * var(--unit-px));
    position: relative;
  }
  .award {
    width: calc(430 * var(--unit-px));
    height: calc(183 * var(--unit-px));
    background: url(~@/assets/img/welfare/award_bind.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(34 * var(--unit-px));
    margin-right: calc(55 * var(--unit-px));
  }
  .btn {
    width: calc(541 * var(--unit-px));
    height: calc(91 * var(--unit-px));
    background: url(~@/assets/img/bg_btn_green.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(34 * var(--unit-px));
    cursor: pointer;
    line-height: calc(91 * var(--unit-px));
    text-align: center;
    font-size: calc(31 * var(--unit-px));
    font-weight: 600;
    color: #473232;
  }
}
</style>
